import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import { Loading } from "@ebsco-ui/ebsco-ui";
import GenericError from "../generic-error";
import {
  fetchGdprPrompt,
  getGdprPromptText,
  getGdprPromptError,
  getGdprPromptLoading
} from "../../store/gdpr";

import sharedMessages from "../../../shared-messages";

function withGdpr(WrappedComponent) {
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }

  return class extends Component {
    static displayName = `withGdpr(${getDisplayName(WrappedComponent)})`;

    componentDidMount() {
      if (!this.props.promptText) {
        this.props.fetchGdprPrompt();
      }
    }

    render() {
      const {
        error,
        intl: { formatMessage },
        loading,
        ...passThroughProps
      } = this.props;
      if (error) return <GenericError />;

      if (loading)
        return (
          <Loading loadingMessage={formatMessage(sharedMessages.loading)} />
        );

      return <WrappedComponent {...passThroughProps} />;
    }
  };
}

const mapStateToProps = state => ({
  error: getGdprPromptError(state),
  loading: getGdprPromptLoading(state),
  promptText: getGdprPromptText(state)
});

const mapDispatchToProps = { fetchGdprPrompt };

export { withGdpr };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withGdpr
);
